import { doc, setDoc } from 'firebase/firestore';
import { IDsiReportSettings } from '../../../providers/settings/reports/dsiReportSettingsProvider';
import { userAsPromise } from '../../../providers/userProvider';

/**
 * @description updates the DSI report settings
 * @param settings
 * @returns
 */
export const updateDSISettings = async (
  settings: IDsiReportSettings
): Promise<void> => {
  const user = await userAsPromise();

  const update: IDsiReportSettings = {
    cmjTags: settings?.cmjTags ?? [],
    isoTags: settings?.isoTags ?? [],
    timeframe: settings?.timeframe,
  };
  return setDoc(
    doc(user.services.firestore, `userProfiles/${user.id}/settings/dsiReport`),
    update,
    { merge: true }
  );
};
